var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusFailedInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "failed_inactive_40px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    fill: "#8F9BBD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 Z M20,1 C9.50658975,1 1,9.50658975 1,20 C1,30.4934102 9.50658975,39 20,39 C30.4934102,39 39,30.4934102 39,20 C39,9.50658975 30.4934102,1 20,1 Z",
    id: "Oval-Copy-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3879613,12.6120387 C28.1669197,13.3909972 28.2023269,14.6319391 27.4941829,15.452896 L27.3879613,15.5672232 L22.9548905,19.9991075 L27.3879613,24.4327768 C28.2040129,25.2488284 28.2040129,26.5719096 27.3879613,27.3879613 C26.6090028,28.1669197 25.3680609,28.2023269 24.547104,27.4941829 L24.4327768,27.3879613 L19.9991075,22.9548905 L15.5672232,27.3879613 C14.7511716,28.2040129 13.4280904,28.2040129 12.6120387,27.3879613 C11.8330803,26.6090028 11.7976731,25.3680609 12.5058171,24.547104 L12.6120387,24.4327768 L17.0443692,19.9991075 L12.6120387,15.5672232 C11.7959871,14.7511716 11.7959871,13.4280904 12.6120387,12.6120387 C13.3909972,11.8330803 14.6319391,11.7976731 15.452896,12.5058171 L15.5672232,12.6120387 L19.9991075,17.0443692 L24.4327768,12.6120387 C25.2488284,11.7959871 26.5719096,11.7959871 27.3879613,12.6120387 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFailedInactive);
export default __webpack_public_path__ + "static/media/status-failed-inactive.99b61a38eef19ae8ec6f5ec8aadc57a1.svg";
export { ForwardRef as ReactComponent };